import { BpFile } from 'components/Files/hooks/useFiles';
import { FileList } from './FileList';

type FileListDownloaderProps = {
  files: BpFile[];
  padding?: 'none' | 'default';
  className?: string | undefined;
};

/* wrapper component for file lists where you can only download */
export const FileListDownloader = ({ files, padding, className }: FileListDownloaderProps) => {
  return (
    <FileList
      actions={['download']}
      files={files}
      padding={padding}
      showHeader
      showSelect
      downloadOnly
      className={className}
    />
  );
};
